import {ArgValidator} from "../Utils/ArgValidator";

/**
 * @class ApiClientOptions - options for api client
 */
export class ApiClientOptions {
    /**
     * @param serverUrl - base server url
     */
    serverUrl: string;

    /**
     * @param jwtToken - security jwt token
     */
    jwtToken: string;

    /**
     * @param keepAliveEnabled - true to enabled keep alive feature; false to disable this feature.
     */
    keepAliveEnabled: boolean;

    /**
     * @param keepAliveTime - time (in seconds) to keep api client alive agains server
     */
    keepAliveTime: number;

    /**
     * @param keepAliveRefreshTime - time (in seconds) to check clients alive state
     */
    keepAliveRefreshTime: number;

    /**
     * @param serverRequestTimeout - time (in milliseconds) of server request runs out of time
     */
    serverRequestTimeout: number;

    constructor(serverUrl: string, jwtToken: string, keepAliveEnabled: boolean, keepAliveTime: number) {
        ArgValidator.ensureStringIsNotNullOrEmpty(serverUrl, 'serverUrl');
        ArgValidator.ensureIsNotNullOrUndefined(keepAliveEnabled, 'keepAliveEnabled');
        ArgValidator.ensureIsNotNullOrUndefined(keepAliveTime, 'keepAliveTime');

        if (keepAliveEnabled && keepAliveTime < 1) {
            throw new Error(`Parameter "keepAliveTime" must be greater or equal the value "1"!`);
        }

        this.serverUrl = serverUrl;
        this.jwtToken = jwtToken;
        this.keepAliveEnabled = keepAliveEnabled;
        this.keepAliveTime = keepAliveTime;
    }

    /**
     * @method enabledKeepAlive - enable keep alive feature.
     * @param time - time in seconds
     */
    public enabledKeepAlive(time: number): void {
        if (time < 1) {
            throw new Error(`Parameter "time" must be greater or equal the value "1"!`);
        }

        this.keepAliveEnabled = true;
        this.keepAliveTime = time;
    }

    /**
     * @method setKeepAliveRefreshTime - set keep alive refresh time.
     * @param time - time in seconds
     */
    public setKeepAliveRefreshTime(time: number): void {
        if (time < 1) {
            throw new Error(`Parameter "time" must be greater or equal the value "1"!`);
        }

        this.keepAliveRefreshTime = time;
    }

    /**
     * @method disableKeepAlive - disable keep alive feature.
     */
    public disableKeepAlive(): void {
        this.keepAliveEnabled = false;
    }

    public setServerRequestTimeout(timeout: number): void {
        this.serverRequestTimeout = null;

        if (timeout > -1) {
            this.serverRequestTimeout = timeout;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/ApiClient/ApiClientOptions.ts
 **/